// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 876) return "static/chunks/876-2e3658d570beb88a.js";
	if (chunkId === 7399) return "static/chunks/7399-c8d1e51667f91b03.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"346":"7f1682090339c799","1667":"e54bd11e87de6de4","1766":"1c5320dca58ee966","1819":"17ad0e4ae1cf51e4","2446":"3982867293b5ab9f","4245":"2e3f1c8b367edada","6391":"e170ba59e729eda2","6732":"086d7f84bb793d40","8002":"73e78d55275a41bf","8400":"235b9a466bfc2ea4","9869":"2c8b9c5fc791e9cc"}[chunkId] + ".js";
};